import { css, Global } from '@emotion/react';
import { Tooltip, type TooltipProps } from '@ui/tooltip';
import { rem } from '@utils';
import type { PropsWithChildren, ReactNode } from 'react';
import Styled from './Chip.styled';

interface Props extends PropsWithChildren {
  className?: string;
  icon?: ReactNode;
  tooltip?: ReactNode;
}

function Chip(props: Props) {
  const content = (
    <Styled.Content>
      {props.icon}
      <span>{props.children}</span>
    </Styled.Content>
  );

  const chipInner = props.tooltip ? (
    <Tooltip
      {...tooltipProps}
      classesTooltip="chip-tooltip"
      className="chip-tooltip-anchor"
      content={props.tooltip}>
      {content}
    </Tooltip>
  ) : (
    content
  );

  return (
    <>
      <Global styles={styles} />
      <Styled.Wrapper className={props.className} hasTooltip={!!props.tooltip}>
        {chipInner}
      </Styled.Wrapper>
    </>
  );
}

const tooltipProps: TooltipProps = {
  content: null,
  children: null,
  placement: 'bottom-start',
  enterDelay: 150,
  enterNextDelay: 150,
  enterTouchDelay: 350,
  leaveDelay: 200,
  leaveTouchDelay: 4000,
  variant: 'white'
};

const styles = css`
  .chip-tooltip {
    && {
      max-width: 240px;
      margin: ${rem(8)} 0 !important;
      padding: ${rem(16)};
    }
  }
`;

export default Chip;
